import _ from 'lodash';
import { array, func, number } from 'prop-types';
import { parse, stringify } from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  resetSearch,
  resetStreamsFilter,
  setStreamsFilter,
  startCopyStream, startRemoveStream,
  startRemoveStreamTDS, startSetStreams, startSetStreamSettings
} from '../../../actions/streams';
import WithAlert from '../../../hoc/WithAlert';
import { debounce, isNil } from '../../../utils/utils';
import { FlowsPageView } from '../index';

const clearEmptyParams = params => {
  const notEmptyParams = {};
  Object.keys(params).map(key => {
    if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
      if (key === 'title' && params[key].length < 3) return;
      notEmptyParams[key] = params[key];
    }
  });
  return notEmptyParams;
};

export const prepareCopyFlow = (data) => {
  const copyData = {}

  copyData.title = data.newTitle
  copyData.site = data.siteId
  copyData.agency = data.agency
  copyData.offer_id = data.offerId
  copyData.trafficback = data.trafficback

  copyData['landings[]'] = data.landings.filter(l => l.selected).map(l => l.id)
  copyData['transits[]'] = data.transits.filter(t => t.selected).map(t => t.id)

  copyData.postback = data.postback.url
  copyData.postback_method = data.postback.method
  copyData['postback_pixels[]'] = data.postback.pixels
  copyData['postback_pixels_status[]'] = data.postback.statuses.filter(p => p.value).map(p => p.id)

  copyData.activate_split_test = data.abTest
  copyData.transit_comebacker = data.transit_comebacker

  if (data.failActions) {
    const selectedAction = data.failActions.find(_ => _.selected);
    if(selectedAction) {
      copyData.fail_type = selectedAction.id;
      copyData.fail_value = selectedAction.value;
    }
  }

  const { landings, transits } = data.settings

  const landings_setting = {}
  landings && Object.keys(landings).forEach(key => {
      landings_setting[`landing_settings[${key}]`] = JSON.stringify(landings[key]);
  })

  const transit_settings = {}
  if (transits) {
    for (const [key, value] of Object.entries(transits)) {
      if (value) {
        transit_settings[`transite_settings[${key}]`] = value
      }
    }
  }


  const tracking = {}
  data.pageTracking.forEach((item, index) => {
    item.forEach(i => {
      if (isNil(i.params)) return
      const key = Object.keys(i.params)[0]
      tracking[`tracking_${i.id}_${key}_${index}`] = i.params[key]
    })
  })

  return { ...copyData, ...landings_setting, ...tracking, ...transit_settings }
}


class FlowsPage extends Component {
  static propTypes = {
    flowsCount: number.isRequired,
    flows: array.isRequired,
    startSetStreams: func.isRequired,
    startRemoveStream: func.isRequired,
  };

  static defaultProps = {
    flows: [],
    flowsCount: 0,
  };

  constructor(props) {
    super(props);

    const { sortBy = null, sortOrder = null, page = 0, limit = 100, title = '' } = parse(
      window.location.search,
      { parseNumbers: true },
    );
    this.state = {
      loading: true,
      page,
      limit,
      showModal: false,
      showModalCopy: false,
      flowId: null,
      flowIdToCopy: null,
      search: title && !!title.length,
      sortOrder,
      sortBy,
      title,
    };
  }

  loadStreams = () => {
    const parsedParams = parse(window.location.search);
    const { sortBy, sortOrder, page, limit, title } = this.state;
    const { startSetStreamSettings, startSetStreams } = this.props
    return startSetStreamSettings().then(() => startSetStreams({ page, limit, sortOrder, sortBy, title, ...parsedParams }))
  };

  updateLocation = params => {
    const parsedParams = parse(window.location.search);
    const queryParams = { ...parsedParams, ...params };
    history.replaceState(
      {},
      null,
      `${window.location.pathname}?${stringify(clearEmptyParams(queryParams))}`,
    );
  };

  componentDidMount() {
    this.loadStreams().finally(() => {
      this.setState(() => ({
        loading: false,
      }));
    });
  }

  // componentWillReceiveProps(nextProps, ) {
  //   const { limit, page, sortBy, sortOrder, title } = this.state;
  //   this.updateLocation({ page, limit, sortOrder, sortBy, title });
  // }

  changePage = newPage => {
    const { limit, page, sortBy, sortOrder, title } = this.state;

    if (page === newPage) return;
    this.setState(() => ({ loading: true, page: newPage }));
    const parsedParams = parse(window.location.search);
    const queryParams = clearEmptyParams({
      ...parsedParams,
      limit,
      page: newPage,
      sortBy,
      sortOrder,
      title,
    });
    this.updateLocation(queryParams);
    this.props.startSetStreams(queryParams).then(() => this.setState(() => ({ loading: false })));
  };

  toggleModal = () => {
    this.setState(prevState => ({ showModal: !prevState.showModal }));
  };

  toggleModalCopy = () => {
    this.setState(prevState => ({ showModalCopy: !prevState.showModalCopy }))
  }

  handleFlowRemove = flowId => {
    this.setState(
      () => ({ flowId }),
      () => {
        this.toggleModal();
      },
    );
  };

  isFlowTDS = id => {
    const { flows } = this.props;
    return _.find(flows, { id }).flow === 'tds';
  };

  removeFlow = () => {
    const { flowId: id } = this.state;
    const { startRemoveStreamTDS, startRemoveStream } = this.props;
    if (this.isFlowTDS(id)) {
      startRemoveStreamTDS(id).then(() => this.toggleModal());
    } else {
      startRemoveStream(id).then(() => this.toggleModal());
    }
  };

  handleFlowCopy = flowId => {
    this.setState({ flowIdToCopy: flowId, showModalCopy: true })
  }

  copyFlow = (newTitle) => {
    const { startCopyStream } = this.props;
    const { flowIdToCopy } = this.state;
    this.toggleModalCopy()
    window.scrollTo(0, 0)
    this.setState({ loading: true }, () => {
      startCopyStream(flowIdToCopy, newTitle, prepareCopyFlow)
        .then(() => this.loadStreams())
        .finally(() => this.setState({ loading: false }))
    })
  }

  resetSearchFilter = () => {
    this.props.resetSearch();
    this.changePage(0);
  };

  handleSearch = (query = '') => {
    // query.length < 3 && this.resetSearchFilter();
    if (!this.state.loading) {
      this.setState({ title: query }, () => {
        this.updateLocation({ title: query });

        if (!query.length) {
          this.setState(() => ({ search: false, title: '' }));
          this.resetSearchFilter();
          this.loadStreams();
        }

        if (query.length > 2) {
          this.searchStreams(query);
        }
      });
    }
  };

  onFilterChange = queryParams => {
    this.setState(() => ({ loading: true }));
    const params = clearEmptyParams({ ...queryParams, ...parse(window.location.search) });
    this.updateLocation(params);
    this.props.startSetStreams(params).finally(() => {
      this.setState(() => ({ loading: false }));
    });
  };

  searchStreams = debounce(() => {
    this.setState(() => ({ loading: true, search: true }));
    const { sortBy, sortOrder, limit, title } = this.state;

    const offerId = parse(window.location.search)['offerId'];

    const params = clearEmptyParams({ limit, page: 0, sortBy, sortOrder, title, offerId });
    this.updateLocation(params);

    this.props
      .startSetStreams(params)
      .finally(() => {
        this.setState(() => ({ loading: false }));
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message: error } = response.data.error;

          this.props.showAlert({
            alertType: 'danger',
            dismissable: false,
            closeInSeconds: 3,
            message: error.message,
          });
        } else {
          this.props.showAlert({
            alertType: 'danger',
            dismissable: false,
            closeInSeconds: 3,
            message: 'Server error',
          });
        }

        this.setState(() => ({ loading: false, search: false }));
      });
  }, 500);

  componentWillUnmount() {
    this.props.resetSearch();
    this.props.resetStreamsFilter();
  }

  findFilters = () => {
    const filters = parse(this.props.location.search);
    if (Object.keys(filters).length > 0) {
      this.props.setStreamsFilter(this.prepareFilters(filters));
    }
  };

  prepareFilters = (items = {}) =>
    Object.keys(items).reduce((filters, key) => {
      if (items[key]) {
        const filter = { [key]: this.normalizeValues(items[key], key) };

        return { ...filters, ...filter };
      }

      return filters;
    }, {});

  normalizeValues = (values = '', param) => {
    const normalized = Array.isArray(values) ? values : values.split(',').filter(String);

    return normalized.map(val => {
      if (!isNaN(val)) {
        return parseInt(val, 10);
      }

      val = ('' + val).trim();

      // if (param === 'countries') {
      //   return val.toUpperCase();
      // }
      return val;
    });
  };

  handleSort = (by, order) => {
    this.setState(
      () => {
        return {
          sortBy: by,
          sortOrder: order,
          page: 0,
        };
      },
      () => {
        const { sortBy, sortOrder, limit, title } = this.state;
        const parsedParams = parse(window.location.search);
        const params = clearEmptyParams({
          ...parsedParams,
          limit,
          page: 0,
          sortBy,
          sortOrder,
          title,
        });
        this.updateLocation(params);
        this.props.startSetStreams(params);
      },
    );
  };

  handleFiltersReset = () => {
    this.props.resetSearch();
    this.props.resetStreamsFilter();
    const { limit } = this.state;
    const params = clearEmptyParams({
      sortBy: null,
      sortOrder: null,
      page: 0,
      limit,
      title: '',
      offerId: null,
    });

    history.replaceState({}, null, `${window.location.pathname}?${stringify(params)}`);
    this.props.startSetStreams(params);
  };

  handleLimitChange = ({ target }) => {
    const { value: limit } = target;

    this.setState(() => ({
      limit,
      loading: true,
      page: 0,
    }));

    const { sortBy, sortOrder, title } = this.state;
    const parsedParams = parse(window.location.search);
    const params = clearEmptyParams({
      ...parsedParams,
      limit,
      page: 0,
      sortBy,
      sortOrder,
      title,
    });
    this.updateLocation(params);
    this.props.startSetStreams(params).then(() => {
      this.setState(() => ({
        loading: false,
      }));
    });
  };

  render() {
    const { limit } = this.state;
    const { flowsCount } = this.props;
    const pageCount = Math.ceil(flowsCount / limit);

    const data = { ...this.props, ...this.state, pageCount };

    return (
      <FlowsPageView
        findFilters={this.findFilters}
        data={data}
        handleSearch={this.handleSearch}
        updateLocation={this.updateLocation}
        changePage={this.changePage}
        handleFlowRemove={this.handleFlowRemove}
        copyFlow={this.copyFlow}
        handleSort={this.handleSort}
        toggleModal={this.toggleModal}
        toggleModalCopy={this.toggleModalCopy}
        removeFlow={this.removeFlow}
        handleFlowCopy={this.handleFlowCopy}
        filtersReset={this.handleFiltersReset}
        handleLimitChange={this.handleLimitChange}
      />
    );
  }
}

const mapStateToProps = ({ streams }) => ({
  flows: streams.streams,
  flowsCount: streams.count,
  base: streams.settings.base
});

const mapDispatchToProps = dispatch => ({
  startSetStreams: params => dispatch(startSetStreams(params)),
  startRemoveStream: streamId => dispatch(startRemoveStream(streamId)),
  startRemoveStreamTDS: streamId => dispatch(startRemoveStreamTDS(streamId)),
  startCopyStream: (streamId, title, callback) => dispatch(startCopyStream(streamId, title, callback)),
  resetSearch: () => dispatch(resetSearch()),
  resetStreamsFilter: () => dispatch(resetStreamsFilter()),
  setStreamsFilter: checked => dispatch(setStreamsFilter(checked)),
  startSearchStreams: params => dispatch(startSearchStreams(params)),
  startSetStreamSettings: () => dispatch(startSetStreamSettings())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithAlert(FlowsPage));
